import api from '../../api/api.js'
import { Message } from 'element-ui'


import {
  SET_STORAGE_USERINFO,
  SET_LOGINSTATUS,
  SET_USER_INFO,
  SET_REGISTOR_SUCCESS,
  SET_LOGIN_STATUS,
  SWITCH_LANG,
  SET_REGISTOR_FALSE

} from '../mutation-types'
import { json } from 'd3'


const state = () => ({
    ModelData:null,
    productIds:[],
    toPrintOrders:[],//用户使用快速打印+打拣临时储存的数据
    isCollapse:false,
    orderInfo:null,
    originData:null,
    distributionOrder:[],//分销商城订单的数据的暂存,
    scrollLocation:0
    
  
  
})

const getters = {}

const actions = {
	
}

const mutations = {

    [SET_REGISTOR_FALSE]: (state,data) =>{
      state.ModelData=data
          console.log('ModelData',state.ModelData)
    },
    [SWITCH_LANG]: (state,data) =>{
      state.productIds=data
          console.log('productIds',state.productIds)
    },
    garner(state,data) {
      console.log('打印的订单数据125',data)
      state.toPrintOrders=data
    },

    getAsideStatu(state,data){
      state.isCollapse=!state.isCollapse
    },
    //卖家修改订单信息时暂存订单信息
    storageOrderInfo(state,data){
      state.orderInfo=JSON.parse(JSON.stringify(data))
    },

    storageOrderInfoCopy(state,data){

      state.originData=data
    },
    addOrderItems(state,data){
      const p = new Promise((resolve) => {
        let ttp=state.orderInfo.items.find(item => item.itemKey == data.itemKey)
        if(ttp){
          Message({
            message: '已存在相同的产品！',
            type: 'warning'
          })
        }else{
          state.orderInfo.items.push(data)

        }
        
      })
     
      return p
    },

    delItems(state,data){
      state.orderInfo.items.splice(data,1)
    },
    changeItems(state,data){
      let index=JSON.parse(JSON.stringify(data.index))
      let orderItem=JSON.parse(JSON.stringify(data.orderItem))
      state.orderInfo.items.splice(index,1,orderItem)
    },
    storerageData(state,data){
      state.distributionOrder=data
      console.log(state.distributionOrder)
    },

    markScrollLocation(state,data){
      state.scrollLocation=data
      console.log('scrollLocation',state.scrollLocation)
    },

    

   
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}